module.exports = __webpack_public_path__ + "static/media/irshad-profile.c1c31f1f.jpg";